<template>
  <div>
    <modal
      class="editCreditLimit"
      name="detailActt"
      transition="pop-out"
      :width="modalWidth"
      :height="480"
      @opened="opened"
    >
      <div class="text-center py-4">
        <h3>
          {{ $t("text.detailAction.detailsFor") }} {{ mtAction.typeName }}
        </h3>
      </div>
      <div class="retainership__box">
        <div class="sign_up_form_section">
          <form>
            <div class="row input_group">
              <div class="col-md-3 mt-4">
                {{ $t("text.detailAction.dueDate") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="mtAction.scheduleDate"
                    placeholder="date"
                    class="form-control border border-2 w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row input_group">
              <div class="col-md-3 mt-4">
                {{ $t("text.detailAction.facilityType") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="mtAction.type"
                    class="form-control border border-2 w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row input_group">
              <div class="col-md-3 mt-4">
                {{ $t("text.detailAction.facilityName") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    type="text"
                    disabled
                    v-model="mtAction.typeName"
                    class="form-control border border-2 w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row input_group">
              <div class="col-md-3 mt-4">
                {{ $t("text.detailAction.status") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section">
                  <input
                    disabled
                    type="text"
                    v-model="mtAction.status"
                    class="form-control border border-2 w-100"
                  />
                </div>
              </div>
            </div>
            <div class="row input_group">
              <div class="col-md-3 mt-4">
                {{ $t("text.detailAction.countDown") }}
              </div>
              <div class="col-md-9">
                <div class="mt-3 form_input_section input-icons">
                  <input
                    disabled
                    type="text"
                    v-model="mtAction.countdown"
                    class="form-control border border-2 w-100"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="btn-group mt-5">
          <div class="mx-auto">
            <button type="button" class="btn btn-warning" @click="trackHistory">
              {{ $t("text.detailAction.trackHistory") }}
            </button>
            <button
              type="button"
              class="btn btn-info"
              @click="maintenanceUpdate"
            >
              {{ $t("text.detailAction.update") }}
            </button>
            <button type="button" class="btn btn-success" @click="openModal">
              {{ $t("text.detailAction.done") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div class="container">
          <h3 class="p-3 text-center">
            {{ $t("text.detailAction.maintenanceTrackDetails") }}
          </h3>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>{{ $t("text.detailAction.description") }}</th>
                <th>{{ $t("text.detailAction.dueDate") }}</th>
                <th>{{ $t("text.detailAction.status") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in maintenanceTracks" :key="item.id">
                <td>{{ item.description }}</td>
                <td>{{ item.date }}</td>
                <td
                  class="badge text-white"
                  :style="[
                    item.isResolved == true
                      ? { backgroundColor: 'green !important' }
                      : { backgroundColor: 'red !important' },
                  ]"
                >
                  {{ item.isResolved }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <UpdateMaintenance :mtSchedule="mtSchedule"></UpdateMaintenance>
    <MarkMaintenance :mtSchedule="mtSchedule"></MarkMaintenance>
  </div>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
import MarkMaintenance from "@/components/modals/markMaintenance/index";
import UpdateMaintenance from "@/components/modals/updateMaintenance/index";
let $ = JQuery;

const MODAL_WIDTH = 956;

export default {
  name: "detailActt",
  props: ["mtAction", "mtSchedule"],
  components: {
    MarkMaintenance,
    UpdateMaintenance,
  },
  data() {
    return {
      // description:"",
      // isResolved:"",
      // date:"",
      isResolved: null,
      maintenanceTracks: [],
      modalWidth: MODAL_WIDTH,
      amount: null,
      comment: null,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;

    this.$eventHub.$on("_openModal", (data) => {
      this.showModal(data);
    });
  },

  mounted() {},
  methods: {
    opened() {
      // console.log(this.mtSchedule);
      this.maintenanceTrack();
      // this.updateMaintenance();
      //  console.log("first modal opened");
    },
    trackHistory() {
      if (this.$route.branchId) {
        this.$router.push(
          `/Industrial/Branch/maintenance-history?typeName=${this.mtAction.typeName}&branchId=${this.$route.query.branchId}&companyId=${this.$route.query.companyId}`
        );
      } else {
        this.$router.push(
          `/Industrial/Branch/maintenance-history?typeName=${this.mtAction.typeName}`
        );
      }
      // console.log(this.data)
    },
    openModal(data) {
      // this.$eventHub.$emit("_openModal", data);
      this.$modal.show("markMaint");
    },
    // link($event, url, data) {
    //   $event.preventDefault();
    //   this.$eventHub.$emit("_link", url, data);
    // },
    maintenanceUpdate() {
      this.$modal.show("updateMaint");
    },
    maintenanceTrack() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/MaintenanceTrack/${this.mtSchedule.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.maintenanceTracks = res.data;
          this.maintenanceTracks.forEach((element) => {
            element.date = this.$moment(element.date).format(
              "MM/DD/YYYY hh:mm A"
            );
          });
        })
        .catch((error) => {});
    },
  },
};
</script>
